export default "__VITE_ASSET__BShJ6mej__"